// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as BadgeTypes$LiteracyplanetSharedClientProfile from "./BadgeTypes.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["query BadgesQuery($userId: uuid!)  {\nbadges: student_badge_collection(args: {p_user_uuid: $userId}, where: {collected: {_eq: false}})  {\nbadgeId  \ncollected  \ndata  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.badges;
  return {
          badges: value$1.map(function (value) {
                return {
                        badgeId: value.badgeId,
                        collected: value.collected,
                        data: value.data
                      };
              })
        };
}

function serialize(value) {
  var value$1 = value.badges;
  var badges = value$1.map(function (value) {
        var value$1 = value.data;
        var value$2 = value.collected;
        var value$3 = value.badgeId;
        return {
                badgeId: value$3,
                collected: value$2,
                data: value$1
              };
      });
  return {
          badges: badges
        };
}

function serializeVariables(inp) {
  return {
          userId: inp.userId
        };
}

function makeVariables(userId, param) {
  return {
          userId: userId
        };
}

var BadgesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var BadgesQuery = {
  BadgesQuery_inner: BadgesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

function parseBadges(badges) {
  return Belt_Array.map(badges, (function (b) {
                return {
                        badgeId: b.badgeId,
                        collected: b.collected,
                        rule: BadgeTypes$LiteracyplanetSharedClientProfile.parseJsonData(b.data)
                      };
              }));
}

export {
  BadgesQuery ,
  parseBadges ,
  BadgesQuery_inner ,
  Raw ,
  query ,
  parse ,
  serialize ,
  serializeVariables ,
  makeVariables ,
  use ,
  useFetch ,
}
/* query Not a pure module */
